export default "__VITE_ASSET__f14bbf71__"